import { htmlAllowedAttrs } from "@/helpers/application/html-allowed-attrs";
import { htmlAllowedEmptyTags } from "@/helpers/application/html-allowed-empty-tags";
import { paragraphFormats } from "@/helpers/application/paragraph-formats";
import { toolbarButtons } from "@/helpers/application/toolbar-buttons";

export const state = {
  applicationSettings: Object.assign({
    // defaults
    darkTheme: true,
    drawerExpanded: true
  }, JSON.parse(localStorage.getItem("app_settings") || "{}")),
  currentNav: null,
  darkThemeBgColor: { backgroundColor: "#121212" },
  froalaConfig: {
    requestWithCORS: true,
    iconsTemplate: "font_awesome_5",

    key: process.env.VUE_APP_FROALA_LICENSE_KEY,

    // disable features
    toolbarButtons: [...toolbarButtons],

    // paragraph formats
    paragraphFormat: {
      ...paragraphFormats
    },

    // html attribute and tag settings
    htmlAllowedAttrs: [...htmlAllowedAttrs],
    htmlAllowedEmptyTags: [...htmlAllowedEmptyTags],

    htmlAllowedTags: [".*"],
    htmlRemoveTags: [""],
    iframe: true,
    iframeStyle: ".fr-view{padding-bottom:3rem!important;max-width:1140px;width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;display:block;box-sizing:border-box;}", // <--- need these styles to have standard text editor rendering whilst using the iframe
    iframeStyleFiles: ["https://storespace.com/css/app.css", "https://pro.fontawesome.com/releases/v5.5.0/css/all.css"],

    // image upload
    imageUploadParam: "image",
    imageUploadURL: `${process.env.VUE_APP_API_HOST}/images/wysiwyg`,
    imageUploadMethod: "POST",
    imageUploadRemoteUrls: true,

    // image manager
    imageManagerLoadURL: `${process.env.VUE_APP_API_HOST}/images/wysiwyg`,
    imageManagerDeleteURL: `${process.env.VUE_APP_API_HOST}/images/wysiwyg`, // just need somewhere that will return a 2xx to the delete
    imageManagerDeleteMethod: "DELETE",

    toolbarStickyOffset: 63
  }
};

// @todo could this be abstracted to a more generic `updateApplicationSettings: ({commit}, setting, newValue) => {}`?
export const actions = {
  setDarkTheme: ({ commit }, newValue) => {
    commit("setDarkTheme", newValue);
    commit("updateApplicationSettings");
  },
  toggleDrawer: ({ commit }, newValue) => {
    commit("setDrawerExpanded", newValue);
    commit("updateApplicationSettings");
  }
};

export const mutations = {
  setDarkTheme: (state, newValue) => {
    state.applicationSettings.darkTheme = newValue;
  },
  setDrawerExpanded: (state, newValue) => {
    state.applicationSettings.drawerExpanded = newValue;
  },
  setCurrentNav: (state, newValue) => {
    state.currentNav = newValue;
  },
  updateApplicationSettings: (state) => {
    localStorage.setItem("app_settings", JSON.stringify(state.applicationSettings));
  }
};

export default {
  state,
  actions,
  mutations
};
